import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import http from "../../../../services/http.service";
import { toast } from "react-toastify";
import { apiPageLimit } from "../../../../constants/common";

const PAYMENT_API_URL = process.env.REACT_APP_PAYMENT_API_URL;

const PLANS = `/subscription-plans`;
const PLAN_PAYMENT_STATUS = `/payment-success`;
const GET_SUBSCRIPTION_OVERVIEW = `/get-subscription`;
const GET_SUBSCRIPTION_HISTORY = `/payment-history`;
const UPGRADE_SUBSCRIPTION = `/billing-portal`;
const CANCEL_SUBSCRIPTION = `/cancel/subscription`;
const CARD_LIST = `cards/list`;
const ADD_NEW_CARD = `cards/add`;
const DELETE_CARD = `cards/delete`;
const SET_DEFAULT_CARD = `cards/update/`;
const PLAN_AUTO_RENEWAL = `/auto-renewal`;
const UPDATE_EMAIL_NOTIFICATION = `/email/notifications`;


export const getAllPlans = createAsyncThunk(
  "getAllPlans",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${PLANS}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getPlanPatmentStatus = createAsyncThunk(
  "getPlanPatmentStatus",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { session_id = "" } = values;

      let response;
      // Create a new Axios instance with the custom base URL
      const customHttp = axios.create({
        baseURL: PAYMENT_API_URL,
      });
      response = await customHttp.get(`${PLAN_PAYMENT_STATUS}?session_id=${session_id}`);

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);


export const getSubscriptionOverview = createAsyncThunk(
  "getSubscriptionOverview",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${GET_SUBSCRIPTION_OVERVIEW}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getSubscriptionHistory = createAsyncThunk(
  "getSubscriptionHistory",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page = 1, limit = apiPageLimit } = values;
      const response = await http.get(`${GET_SUBSCRIPTION_HISTORY}?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const upgradeSubscription = createAsyncThunk(
  "upgradeSubscription",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${UPGRADE_SUBSCRIPTION}`, {device_type: "web"});
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const cancelSubscription = createAsyncThunk(
  "cancelSubscription",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${CANCEL_SUBSCRIPTION}`);
      toast.success(response?.data?.message || "Subscription cancelled successfully.");

      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to cancel subscription");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const getCardList = createAsyncThunk(
  "getCardList",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${CARD_LIST}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const addNewCard = createAsyncThunk(
  "addNewCard",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${ADD_NEW_CARD}`, values);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteCard = createAsyncThunk(
  "deleteCard",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${DELETE_CARD}`, values);
      toast.success(response?.data?.message || "Card deleted successfully.");

      dispatch(getCardList());
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to delete card");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const setDefaultCard = createAsyncThunk(
  "setDefaultCard",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { card_id = "" } = values;
      const response = await http.put(`${SET_DEFAULT_CARD}${card_id}`, { "set_default": true });
      toast.success(response?.data?.message || "Card updated successfully.");

      dispatch(getCardList());
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to update card");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const planAutoRenewal = createAsyncThunk(
  "planAutoRenewal",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${PLAN_AUTO_RENEWAL}`, values);
      toast.success(response?.data?.message || "Card deleted successfully.");

      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to delete card");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const updateEmailNotification = createAsyncThunk(
  "updateEmailNotification",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${UPDATE_EMAIL_NOTIFICATION}`, values);
      toast.success(response?.data?.message || "Card deleted successfully.");

      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to delete card");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);
